export default "__VITE_ASSET__BdARGQYp__"